export const PROGRESS = {
  SHAPE: { ROUND: "round", DEFAULT: "default" },
};